// Project service for loading projects from external API with secure authentication
class ProjectService {
  constructor() {
    this.apiUrl = '/projekte/projects.json';
  }

  /**
   * Fetch projects from external API (no authentication needed)
   * @returns {Promise<Array>} Array of projects
   */
  async fetchProjects() {
    console.log('🌐 Attempting to load projects from external API:', this.apiUrl);
    
    const response = await fetch(this.apiUrl, {
      method: 'GET',
      mode: 'cors'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const projects = await response.json();
    
    // Sort projects by sort field (low numbers first)
    const sortedProjects = projects.sort((a, b) => {
      const sortA = a.sort || 999; // Default high value if no sort field
      const sortB = b.sort || 999;
      return sortA - sortB;
    });
    
    console.log('✅ Successfully loaded', sortedProjects.length, 'projects from external API');
    console.log('📊 External API data sample:', sortedProjects.slice(0, 2));
    
    return sortedProjects;
  }


  /**
   * Get projects filtered by goal/ziel
   * @param {string} goalName - The goal name to filter by
   * @returns {Promise<Array>} Projects matching the goal
   */
  async getProjectsByGoal(goalName) {
    const projects = await this.fetchProjects();
    return projects.filter(project => {
      // Check if ziel is an array (multiple goals)
      if (project.ziel && Array.isArray(project.ziel)) {
        return project.ziel.some(ziel => 
          ziel && ziel.toLowerCase().includes(goalName.toLowerCase())
        );
      } else if (project.ziel && typeof project.ziel === 'string') {
        // Single goal as string
        return project.ziel.toLowerCase().includes(goalName.toLowerCase());
      }
      return false;
    });
  }

  /**
   * Get all unique goals/ziele from all projects
   * @returns {Promise<Array>} Array of unique goal names
   */
  async getAllGoals() {
    const projects = await this.fetchProjects();
    const allGoals = new Set();
    
    projects.forEach(project => {
      if (project.ziel && Array.isArray(project.ziel)) {
        project.ziel.forEach(ziel => {
          if (ziel && ziel.trim()) {
            allGoals.add(ziel.trim());
          }
        });
      } else if (project.ziel && typeof project.ziel === 'string' && project.ziel.trim()) {
        // Single goal as string
        allGoals.add(project.ziel.trim());
      }
    });
    
    return Array.from(allGoals).sort();
  }
}

export default new ProjectService();